import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import { STATISTIC_GOALS_GET } from 'api/query-keys.ts';
import type { TCargoType, TGetGoalsStatisticsRes } from 'api/swagger';
import { setFiltersToQs } from 'shared/utils/filters/set-filters-to-qs';

interface IParams {
  date: string;
  period: 'day' | 'week';
  transportLine: string;
  cargoTypes: TCargoType[];
}

export const useGetGoalsStatistic = (params: IParams) => {
  const qs = new URLSearchParams();

  setFiltersToQs<IParams>(qs, params);

  return useQuery<TGetGoalsStatisticsRes>({
    queryKey: [STATISTIC_GOALS_GET, { params }],
    queryFn: async () => {
      const { data } = await http.get<TGetGoalsStatisticsRes>(`/v1/statistics/goals?${qs.toString()}`);
      return data;
    },
    retry: false,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    enabled: !!params.transportLine,
  });
};
